export const isEnglishTitle = (title = '') => {
  // 영어 문자와 한글 문자 수 계산 (공백과 특수문자 제외)
  const englishCount = title.replace(/[^A-Za-z]/g, '').length;
  const koreanCount = title.replace(/[^가-힣]/g, '').length;  // 한글 범위만 정확하게 지정

  // 영어책 판별 조건:
  // 1. 영어 문자가 3자 이상이고 한글이 없는 경우
  // 2. 영어 문자 수가 한글 문자 수보다 많은 경우
  return (englishCount >= 3 && koreanCount === 0) || englishCount > koreanCount;
};
